import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { INVALID_INPUT } from '../../../constants/notification-messages';
import { setShouldSendEmail } from '../../../store/orders/orders.actions';
import { shouldSendEmail } from '../../../store/orders/orders.selector';
import {
  deliveryTimes,
  selectedRestaurant,
} from '../../../store/restaurants/restaurants.selector';
import { getDeliveryTimesAsync } from '../../../store/restaurants/restaurants.thunk';
import Checkbox from '../../atoms/Checkbox/Checkbox';
import SelectInput from '../../atoms/SelectInput/SelectInput';
import Textarea from '../../atoms/Textarea/Textarea';
import CheckboxGroup from '../../molecules/CheckboxGroup/CheckboxGroup';

const Step6 = () => {
  const sendMail = useSelector(shouldSendEmail);
  const dispatch = useDispatch();
  const restaurant = useSelector(selectedRestaurant);
  const [location, setLocation] = useState('');
  const deliveryTimeOptions = useSelector(deliveryTimes);
  useEffect(() => {
    dispatch(getDeliveryTimesAsync());
  }, []);

  return (
    <center>
      {/*checks if restaurant enables you to choose delivery locations*/}
      {restaurant.locationOption && (
        <>
          <SelectInput
            label="Delivery Location"
            name="deliveryLocation"
            options={[
              { value: 'Office', label: 'Office' },
              { value: 'Restaurant', label: 'Restaurant' },
            ]}
            onChange={(value) => {
              setLocation(value);
            }}
          />
          {/*Only show if 'restaurant' is selected*/}
          {location === 'Restaurant' && (
            <SelectInput
              label="Delivery Time"
              name="deliveryTime"
              options={(deliveryTimeOptions || []).map((time) => ({
                value: time,
                label: time,
              }))}
            />
          )}
        </>
      )}
      <Textarea
        name="comment"
        numberOfRows={10}
        label="Order Comment"
        placeholder="For example... No ketchup for my order, no salt, I'm allergic to peanuts, etc..."
        required={false}
        validation={{
          maxLength: 200,
          maxLengthMessage: INVALID_INPUT['COMMENT_LENGTH'],
        }}
      />
      <CheckboxGroup>
        <Checkbox
          label="Do you want to receieve email notifications?"
          name="shouldSendEmail"
          checked={sendMail}
          onClick={() => dispatch(setShouldSendEmail(!sendMail)())}
        />
      </CheckboxGroup>
    </center>
  );
};

export default Step6;
